import { render, staticRenderFns } from "./center.vue?vue&type=template&id=1aaf3f85&scoped=true&"
import script from "./center.vue?vue&type=script&lang=js&"
export * from "./center.vue?vue&type=script&lang=js&"
import style0 from "./center.vue?vue&type=style&index=0&id=1aaf3f85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../ytht-h5/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf3f85",
  null
  
)

export default component.exports